var content = require("!!../../../../../../css-loader/dist/cjs.js??ref--5-1!../../../../../../sass-loader/dist/cjs.js!./findWidget.css");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
